import type { LayoutProps } from "../types";

export default function GridLayout({ theme, template, articles, language }: LayoutProps) {
  const t = theme;
  const live = articles.slice(0, 3);
  const cards = articles;
  const tickerLabel = language === "en" ? "LIVE" : "DIRECT";
  const wireLabel = language === "en" ? "Wire" : "Fil";

  return (
    <div style={{ background: t.palette.bg, color: t.palette.ink, fontFamily: t.typography.body }}>
      {/* Live ticker bar */}
      <div style={{ background: t.palette.accent, color: t.palette.accentInk, fontFamily: t.typography.meta, letterSpacing: "0.16em" }} className="flex items-center gap-3 px-6 py-2 text-[11px] uppercase">
        <span className="flex h-2 w-2 animate-pulse rounded-full" style={{ background: t.palette.accentInk }} />
        <span className="font-bold">{tickerLabel}</span>
        <span className="opacity-60">|</span>
        <span className="flex flex-1 gap-6 overflow-hidden">
          {live.map((a) => (
            <span key={a.id}>
              <span className="font-semibold">{a.kicker}</span> &middot; {a.title}
            </span>
          ))}
        </span>
      </div>

      {/* Masthead strip */}
      <header style={{ borderBottom: `1px solid ${t.palette.rule}` }} className="flex items-center justify-between px-6 py-5">
        <h1
          style={{
            fontFamily: t.typography.masthead,
            color: t.palette.ink,
            letterSpacing: t.ornaments.letterspacing === "wide" ? "0.08em" : "0.02em",
          }}
          className="text-3xl font-bold uppercase"
        >
          {template.name}
        </h1>
        <span style={{ fontFamily: t.typography.meta, color: t.palette.muted, letterSpacing: "0.18em" }} className="text-[11px] uppercase">
          {wireLabel} 24/7 &middot; {articles[0]?.date}
        </span>
      </header>

      {/* 12-col dense grid */}
      <main className="grid grid-cols-12 gap-px px-6 py-6" style={{ background: t.palette.rule }}>
        {cards.map((a, i) => {
          const span = i === 0 ? "col-span-12 md:col-span-6" : i === 1 ? "col-span-12 md:col-span-6" : i < 4 ? "col-span-12 md:col-span-4" : "col-span-6 md:col-span-3";
          const tall = i < 2;
          return (
            <article key={a.id} className={`${span} flex flex-col`} style={{ background: t.palette.surface }}>
              <div style={{ borderBottom: `1px solid ${t.palette.rule}` }} className={`relative w-full ${tall ? "h-56" : "h-32"}`}>
                <img src={a.imageUrl} alt="" className="h-full w-full object-cover" />
                <span
                  style={{ background: t.palette.ink, color: t.palette.bg, fontFamily: t.typography.meta, letterSpacing: "0.18em" }}
                  className="absolute left-0 top-0 px-2 py-1 text-[10px] font-bold uppercase"
                >
                  {a.kicker}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-3">
                <span style={{ fontFamily: t.typography.meta, color: t.palette.muted, letterSpacing: "0.12em" }} className="text-[10px] uppercase">
                  {a.date} &middot; {a.byline}
                </span>
                <h3
                  style={{ fontFamily: t.typography.headline, color: t.palette.ink, letterSpacing: "-0.005em" }}
                  className={`mt-1 ${tall ? "text-xl" : "text-base"} font-semibold leading-tight`}
                >
                  {a.title}
                </h3>
                {tall && (
                  <p style={{ fontFamily: t.typography.body, color: t.palette.muted }} className="mt-2 text-sm leading-6">
                    {a.dek}
                  </p>
                )}
              </div>
            </article>
          );
        })}
      </main>
    </div>
  );
}
